//export const baseUrl =  'http://89.116.187.234:10053'; /** Radix Backend Oracle Server */
const radixTest = process.env.REACT_APP_BOOK_APP_URL;
export const getBaseUrl = (service) => {
    console.log('Param service is:', service);
  switch (service) {
    case 'TEST':
       return radixTest;
//     case 'DYBQR53':
//       return devDB;
//     case 'TEST_01 ADW':
//       return UAT;
//     case 'DYBQR03':
//       return prodDB;
    default:
      return radixTest;
  }
};

console.log('Radix Oracle URL:', radixTest);

export const pecaDbName = 'TEST';
//export const pecaDbName = 'DYBQR53';
//export const pecaDbName = 'TEST_01 ADW';
//export const pecaDbName = 'DYBQR03';
export const baseUrl = getBaseUrl(pecaDbName);
console.log('PECA_Reactjs_pecaDbName, baseUrl is:', pecaDbName, baseUrl);